<template>
	<div>
		<b-modal :size="'lg'"
			ref="previewModal"
			static="true"
			:lazy=true
			ok-only>
			<div class="embed-responsive embed-responsive-16by9">
				<video class="embed-responsive-item"
					:src="preview_path"
					ref="playerpreview"
					controls
					height="600"
					width="800"></video>
			</div>
		</b-modal>

		<!--		<b-button class="btn_add_person">{{ $t('VideoPrivacy.exportAllButtonText')}}</b-button>-->
		<!--		<b-button @click="addPerson" class="btn_add_record">{{ $t('VideoPrivacy.addPersonButtonText')}}</b-button>-->

		<div id="admin_controls">
			{{ $t("VideoLibrary.search") }}<input class="form-control no-border" type="text" v-model="filter" />
		</div>

		<div id="admin_videotheque">
			<div v-for="video in video_list" @click="preview(video.file)" class="video-item">

				<div class="thumbnail"><img v-if="video.thumbnail" :src="video.thumbnail"></div>

				<p class="description">{{ $t("VideoLibrary.author") }} {{ video.name }} <span>({{ video.email }})</span>
				</p>
				<p class="date">{{ video.date_obj.toLocaleDateString($t('date_locale')) }}</p>
			</div>

		</div>

		<b-pagination
			v-model="current_page"
			:total-rows="total_projects"
			:per-page="per_page"
			align="center"
		></b-pagination>
	</div>
</template>

<script>
import Navbar from "@/components/ui/Navbar";
import axios from "axios";
import {EventBus} from "../../event/event-bus";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	components: {Navbar},
	name: "VideothequeAdmin",
	data() {
		return {
			languages: [
				{flag: "static/images/flags/fr.svg", language: "fr", title: "Français"},
				{flag: "static/images/flags/en.svg", language: "en", title: "English"},
			],
			videos: [],
			sorting_attr: "date_sorting",
			sorting_order: -1,
			preview_path: null,
			filter: "",

			per_page: 8,
			current_page: 1,
		};
	},
	activated() {
		// EventBus.$on('setLanguage', function () {
		// 	// $this.getDatas($this.id);
		// });
	},
	created() {
		this.getData();
		let $this = this;
		EventBus.$on("setLanguage", lang => {
			$this.$root.$i18n.locale = lang;
		});
	},
	methods: {
		sortData() {
			let $attr = this.sorting_attr;
			let $order = this.sorting_order;

			this.videos.sort(function (a, b) {
				let val1 = a[$attr].toString();
				let val2 = b[$attr].toString();

				if (val1 < val2) {
					return -$order;
				}
				if (val1 > val2) {
					return $order;
				}
				return 0;
			});
		},
		filterData(project) {
			let locale = this.$root.$t("date_locale");
			return project.name.includes(this.filter) ||
				project.email.includes(this.filter) ||
				project.date_sorting.includes(this.filter) ||
				project.date_obj.toLocaleDateString(locale).includes(this.filter);
		},
		getData() {
			let $this = this;
			let project_data = [];

			// Absolute url because this service isn't integrated to the rest of the API
			axios.get(BASE_URL + "/public/api/admin/projects", {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				let projects = response.data;
				projects.forEach(function (project) {
					let date = new Date(project.datetime);
					let obj = {
						file: project.file,
						name: project.name,
						category: project.category,
						email: project.email,
						thumbnail: project.thumbnail || null,
						date_sorting: project.datetime,
						date_obj: date,
					};

					project_data.push(obj);
				});

				$this.videos = project_data;
				$this.sortData();
			}).catch(error => {
				$this.text_error = "L'erreur suivante est survenue. Merci de nous contacter, "
					+ "et veuillez nous excuser pour la gêne occasionnée.\nErreur : " + error.response;
				$this.$refs.modalError.show();
			});
		},
		preview(url) {
			this.preview_path = url;
			this.$refs.previewModal.show();
		},
	},
	computed: {
		recordsByName() {
			let array = this.records.slice();
			return array.reverse();
		},
		video_list() {
			let selection = this.videos.filter(this.filterData);
			return selection.slice((this.current_page - 1) * this.per_page, this.current_page * this.per_page);
		},
		total_projects() {
			return this.videos.filter(this.filterData).length;
		},
	},
};
</script>

<style scoped>
#admin_controls {
	margin: 24px 12px 0;
}

#admin_controls input {
	width: 300px;
	border: 1px solid var(--color-border-inputs);
}

#admin_videotheque {
	display: flex;
	flex-wrap: wrap;
	/*justify-content:center;*/
	margin: 0 0 24px;
}

.video-item {
	width: 250px;
	margin: 24px 12px 0;
	background: var(--color-background);
	border-radius: 10px;
	overflow: hidden;
	color: var(--text-main);
	cursor: pointer;
}

.video-item .thumbnail {
	width: 250px;
	height: 140px;
	overflow: hidden;
	margin: 0 auto;
	background: url("/static/images/placeholder.png") center/contain;
	border-radius: 10px;
	display: grid;
	grid-template-rows: 140px;
	grid-template-columns: 250px;
}

.video-item .thumbnail img {
	width: 100%;
	display: block;
	border-radius: 10px;
	place-self: center;
}

.video-item .description {
	margin: 10px 16px 13px;
}

.video-item .description span {
	display: block;
	font-size: 0.7em;
}

.video-item .date {
	margin: 5px 16px;
	font-size: 0.7em;
}
</style>
